module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/191.b03f7706.png";